import User from '../stores/UserStore';
import General from '../stores/GeneralStore';

import axios from 'axios';
import { normalizePayloadAmounts } from './money';


export async function callRemoteMethod({
  endpoint,
  type = 'GET',
  data = {} || [],
  file = false,
  successKey = true,

}) {
  const method = type.toLowerCase();

  try {
    let options = {
      method: method,
      url: endpoint,
      headers: await getRequestHeader(file),
    };

    // Every request in the app leaves through here, so this is the one place
    // that can guarantee no money field ever reaches a payment gateway with
    // more than 2 decimal places - the gateway rejects the whole request when
    // it does ("money supports only 2 decimal places, but got: 13"). File
    // uploads and anything that is not a well-formed amount pass through
    // untouched; see normalizePayloadAmounts in ./money.
    const payload = file ? data : normalizePayloadAmounts(data);

    (type === 'POST' ||
      type === 'PUT' ||
      type === 'PATCH' ||
      type === 'DELETE') &&
      (options.data = payload);


    if (file)
      options.responseType = 'blob'

    const response = type === 'GET' && (Object.keys(data).length > 0) ? await axios.get(endpoint, { params: payload, headers: options.headers }) : await axios(options);

    if (response.status === 200) {

      if (successKey) {
        if (response.data) {
          return response.data ? response.data : response;
        }
      }
    } else {
      throw { response: response };
    }
  } catch (err) {

    if (err.response && err.response.status) {
      const fromUaePass = localStorage.getItem('redirectFrom');
      let { info } = await User;
      console.log(err, 'err.responseerr.response');
    if(err.response.status === 401){
      if(fromUaePass !== 'uaePassLogin' && info?.token){
         User.logout();
      }
    }
      throw err.response.data;
      handleStatus(err.response);
    }
  }
}

function handleStatus(response) {
  console.log(
    'ERROR!',
    JSON.stringify(response.data?.message),
    response.status
  );

  switch (response.status) {
    case 400:
      console.warn('Bad request', response.data);
      throw new Error(response.data);
    case 401:
      console.warn('Unauthorized Access');
      break;
    case 403:
      console.warn('Forbidden Access');
      break;
    case 404:
      console.warn('Not Found');
      break;
    case 500:
      console.warn('Internal Server Error');
      break;
    default:
      console.warn('Something went wrong! Please try again later.');
  }
}

async function getRequestHeader(file = false) {
  let { info, initialInfo } = await User;
  let { token } = await General;

  const header = {
    Accept: `application/${file ? 'octet-stream' : 'json'}`,
    'Content-Type': `application/${file ? 'octet-stream' : 'json'}`,
    CurrentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US",
  };

  // Check token from multiple sources and prioritize it
  const bearerToken = info.token || initialInfo.token || token;
  if (bearerToken) {
    header.Authorization = `Bearer ${bearerToken}`;
  }

  return header;
}

